import React, { useContext, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { Dropdown } from 'ncoded-component-library';
import useCallbackRef from 'hooks/useCallbackRef';
import { DropdownRef } from 'ncoded-component-library/build/components/molecules/Dropdown/Dropdown.component';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { useLocation } from 'react-router-dom';
import ResolveImage from 'components/ResolveImage';
import { NavigationList } from '../ResolveHeader/components/NavigationList';
import { getImgUrl } from 'components/ResolveImage/utils';

import './ProfileDropdown.styles.scss';

type ProfileDropdownProps = {
  className?: string;
};

const ProfileDropdown: React.FC<ProfileDropdownProps> = (props) => {
  const { className, children } = props;

  const [dropdown, dropdownRef] = useCallbackRef<DropdownRef>();

  const {
    currentUser: { profileImage },
  } = useContext(CurrentUserContext);

  const { pathname } = useLocation();

  const classes = classNames('profile-dropdown', className);

  const renderTrigger = useMemo(
    () => (
      <div className="profile-dropdown__trigger">
        <ResolveImage asAvatar src={getImgUrl(profileImage?.url, '100')} />
      </div>
    ),
    [profileImage],
  );

  useEffect(() => {
    dropdown?.setIsOpen(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <Dropdown
      ref={dropdownRef}
      closeWithJS
      className={classes}
      renderAsPortal
      portalClassName="profile-dropdown-portal"
      trigger={renderTrigger}
    >
      <NavigationList onClose={() => dropdown?.setIsOpen(false)}>
        {children}
      </NavigationList>
    </Dropdown>
  );
};

export default ProfileDropdown;
